import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { FooterComponent } from './layout/footer/footer.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PreloaderComponent } from './util/preloader/preloader.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { LoadingService } from './service/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    PreloaderComponent,
    FormsModule,
    RouterOutlet,
    LoginComponent,
    FooterComponent,
    CommonModule,
    NgxSpinnerModule,
    NgxLoadingModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title: string = '';
  isLoading = true;
  loading = false;
  data: any;
  constructor(private loadingService: LoadingService) {}
  ngOnInit() {
    // Check if user is on the old domain and redirect to new domain
    this.checkAndRedirectDomain();

    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }

  /**
   * Checks if the current domain is the old domain (pbtpa.aclarian.com)
   * and redirects to the new domain (pbmpo.aclarian.com) if needed
   */
  private checkAndRedirectDomain(): void {
    const currentHost = window.location.hostname;
    const oldDomain = 'pbtpa.aclarian.com';
    const newDomain = 'pbmpo.aclarian.com';

    // Check if we're on the old domain
    if (currentHost === oldDomain) {
      // Get the current path and query parameters
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const currentHash = window.location.hash;

      // Build the new URL with the new domain
      const newUrl = `https://${newDomain}${currentPath}${currentSearch}${currentHash}`;

      // Perform a full page redirect (necessary for domain change)
      window.location.replace(newUrl);
    }
  }

  ngAfterContentChecked(): void {
    this.loadingService.OnLoading.subscribe((data: boolean) => {
      if (this.loading != data) {
        this.loading = data;
      }
    });
  }
}
